/**
 * @file installBaseDockFeatures.ts
 * @description 底座 feature 装配工具。设备类用它挂载公共底座功能，不通过继承复用。
 */

import type { HidChannel } from '../../../../channels/hid/HidChannel'
import type { BaseDevice } from '../../../../runtime/BaseDevice'
import { RapooBaseConfig } from '../../../../chips/shared/feature-impls/base-config/config'
import { RapooBaseFirmware } from '../../../../chips/shared/feature-impls/base-firmware/firmware'
import { RapooBaseLighting } from '../../../../chips/shared/feature-impls/base-lighting/lighting'
import { RapooBaseScreen } from '../../../../chips/shared/feature-impls/base-screen/screen'
import { RapooBaseSettings } from '../../../../chips/shared/feature-impls/base-settings/settings'
import type { BaseDockProfile } from '../../../../chips/shared/capabilities/base-command/profile'
import { VTNrf54LBasePairing } from '../../../../chips/nordic-nrf54l/feature-impls/base/pairing'

export type BaseScreenChannelResolver = (
  usagePage: number,
  usage: number,
) => Promise<HidChannel | null>

export interface BaseDockFeatureInstallOptions {
  device: BaseDevice
  profile: BaseDockProfile
  screenChannelResolver?: BaseScreenChannelResolver
}

/** 挂载底座通用 feature，具体设备决定是否注入屏幕上传通道解析器。 */
export function installBaseDockFeatures(options: BaseDockFeatureInstallOptions): void {
  const { device, profile, screenChannelResolver } = options

  // 约定：这里只做 feature 装配，不持有芯片状态，也不处理任何底座 report。
  // 底座恢复出厂统一走 config.initAllConfigs（base-config）。
  device.features.config = new RapooBaseConfig(device, profile)
  device.features.baseLighting = new RapooBaseLighting(device, profile)
  device.features.baseScreen = new RapooBaseScreen(device, profile, screenChannelResolver)
  device.features.baseSettings = new RapooBaseSettings(device, profile)
  device.features.firmware = new RapooBaseFirmware(device, profile)
  if (profile.name === 'VT_nrf54L_Base') {
    device.features.pairing = new VTNrf54LBasePairing(device)
  }
}
